export interface OutputQuickAction {
  id: "humanize" | "fact_check";
  label: string;
  description?: string;
  promptTemplate: string;
  icon?: string;
  sortOrder?: number;
}

export const OUTPUT_QUICK_ACTIONS: OutputQuickAction[] = [
  {
    id: "humanize",
    label: "Humanize",
    description:
      "Rewrite to sound more human and natural, reduce AI-detector signals, keep meaning intact.",
    promptTemplate: `I need you to take the output that you provided and just slightly alter it to make it more human and less AI
the following are general instructions on how you can do it, you don't have to apply all of them, beware of the document type and apply those who are relevant


0.  Never ever use — (em dash), either use - (en dash) or nothing, don't abuse en dash

1. Vary sentence length and rhythm
	•	AI tends to produce evenly balanced sentences.
	•	Add occasional short punchy lines. Mix in long, meandering ones.
	2.	Introduce imperfection
	•	Allow minor grammar quirks or informal punctuation (em dashes, ellipses, semicolons, run-ons).
	•	Avoid overly consistent use of commas and colons.
	3.	Add colloquial flavor
	•	Insert idioms, filler words (“kind of,” “honestly,” “let’s face it”).
	•	Use contractions naturally (“don’t” instead of “do not”).
	4.	Lexical diversity & synonyms
	•	Replace “polished” words with synonyms that feel slightly less optimized.
	•	Use variety in phrasing (e.g., “clients” → “customers,” “messy” → “chaotic”).
	5.	Inject subjectivity and personality
	•	Sprinkle in hedges (“I think,” “probably,” “to be honest”).
	•	Add rhetorical questions (“Sound familiar?” “Ever been there?”).
	6.	Break patterns in lists
	•	Instead of perfectly parallel bullet points, make some longer/shorter, some phrased as fragments, others as full sentences.
	7.	Use narrative & tangents
	•	Humans drift: add quick anecdotes, small asides, or contextually relevant but non-essential comments.
	8.	Allow small errors or inconsistencies
	•	Occasional awkward phrasing or tense mismatch (“things gets messy fast”) actually lowers “AI-likeness.”`,
    icon: "Smile",
    sortOrder: 10,
  },
  {
    id: "fact_check",
    label: "Fact-check",
    description:
      "Verify accuracy using the web and reasoning, and correct any inaccuracies while preserving structure and tone.",
    promptTemplate:
      "Fact-check and correct inaccuracies. Use web search and reasoning to validate claims. Preserve the original structure, tone, and length unless corrections are necessary.",
    icon: "ShieldCheck",
    sortOrder: 20,
  },
];
